import { createAction, props } from '@ngrx/store';
import { Encounter, LabValue, PageableModel, ParamsModel } from '@mona/models';

/**
 * Lab values actions
 */
export class LabValuesAction {
    static setLoadingAction = createAction('ENCOUNTER:SET_LAB_VALUES_LOADING', props<{ isLoading: boolean }>());

    static loadLabValues = createAction(
        'ENCOUNTER:LOAD_LAB_VALUES_PAGINATED',
        props<{ params?: ParamsModel & { encounter_id?: EntityId<Encounter> }; url?: string }>(),
    );
    static loadLabValuesSuccess = createAction(
        'ENCOUNTER:LOAD_LAB_VALUES_PAGINATED_SUCCESS',
        props<PageableModel<LabValue>>(),
    );
    static loadLabValuesFailed = createAction(
        'ENCOUNTER:LOAD_LAB_VALUES_PAGINATED_FAILED',
        props<{ error: unknown }>(),
    );
    /**
     * Emitted when an in-flight `loadLabValues` is aborted because the selected encounter
     * was cleared mid-fetch. Pairs with the race in `loadLabValues$` so the reducer can
     * drop `isLoading: true` instead of leaving any consumer of `selectIsLoadingLabValues`
     * staring at a permanent spinner. Defensive twin of the procedure-prescription fix
     * — lab-values has the exact same `takeUntil` + `removeAll(state)` shape.
     * Refs: MD-9750.
     */
    static loadLabValuesCancelled = createAction(
        'ENCOUNTER:LOAD_LAB_VALUES_PAGINATED_CANCELLED',
        props<{ reason: string }>(),
    );
    static upsertLabValues = createAction('ENCOUNTER:UPSERT_LAB_VALUES', props<{ data: LabValue[] }>());

    static removeLabValues = createAction('ENCOUNTER:REMOVE_LAB_VALUES', props<{ ids: string[] }>());

    static clearLabValues = createAction('ENCOUNTER:CLEAR_LAB_VALUES');

    static addChanges = createAction(
        'ENCOUNTER:ADD_LAB_VALUES_CHANGES',
        props<{ toUpdateEntities: LabValue[]; toRemoveIds: string[] }>(),
    );
}
